import { useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { Translate } from 'react-redux-i18n'
import { useNavigate } from 'react-router'
import { Button } from '../../../../common/html/button'
import { Element } from '../../../../common/html/element'
import { Icon } from '../../../../common/html/icon'
import { PopupCreateCompany } from '../components/popupAddCompany/index'
import { downloadSavedPortfolio } from '../store/thunk'

import { useSearchParams } from 'react-router-dom'
import { UseI18n } from '../../../../common/hooks/useI18n'
import EventEmitter, {
  SHOW_POPUP_ERROR,
  SHOW_POPUP_UPGRADE,
} from '../../../../helpers/EventEmitter'
import { selectUserType } from '../../../../layout/store/slice'
import { COMPONENTS } from '../../../../routers/constants'
import { USER_TYPE } from '../../../../utils/authorization'
import style from '../index.module.scss'
import { selectDataFilter, selectIdsTablePortfolioDetail } from '../store/slice'

const COMPANY_LIMIT = 500

export const GroupBtn = () => {
  const dispatch = useDispatch()
  const navigate = useNavigate()
  const [searchId] = useSearchParams()
  const id = searchId.get('id')

  const ids = useSelector(selectIdsTablePortfolioDetail)
  const totalCompanies = useSelector(selectDataFilter)
  const userType = useSelector(selectUserType)

  const textValidate = UseI18n('library.main.VALIDATE_COMPANY')
  const isDisable = ![USER_TYPE.PREMIUM, USER_TYPE.TRIAL].includes(
    userType.userTypeId,
  )
    ? true
    : [USER_TYPE.PREMIUM, USER_TYPE.TRIAL].includes(userType.userTypeId) &&
      !ids.length
    ? true
    : false

  const [isShow, setShow] = useState(false)

  const handleAddCompany = () => {
    if (totalCompanies?.totalRecords >= COMPANY_LIMIT) {
      EventEmitter.dispatch(SHOW_POPUP_ERROR, {
        messages: [textValidate],
      })
      return null
    }
    setShow(true)
  }

  const handleExport = () => {
    if (ids.length) {
      dispatch(
        downloadSavedPortfolio({
          PortfolioId: id,
        }),
      )
    }
  }

  const actionViewInsight = () => {
    if ([USER_TYPE.PREMIUM, USER_TYPE.TRIAL].includes(userType.userTypeId)) {
      if (!ids.length) return
      navigate(
        `${COMPONENTS.portfolioInsights.components.summary.route}?library=true&portfolio=${id}`,
      )
    } else {
      EventEmitter.dispatch(SHOW_POPUP_UPGRADE)
    }
  }

  return (
    <>
      <div className={['dFlex justifyContentBetween', style.action].join(' ')}>
        <Button
          className={style.createBtn}
          style={{
            color: '#ffffff',
            backgroundColor: '#2c73e8',
          }}
          label="library.detailsPortfolios.ADD_COMPANY"
          action={handleAddCompany}
          isI18n
        />
        <Element className="dFlex gap1">
          <Button
            className={style.view}
            style={{
              color: !isDisable ? '#2c73e8' : '#9C9C9C',
              backgroundColor: '#ffffff',
              borderColor: !isDisable ? '#6d9dcf' : '#9C9C9C',
            }}
            label={
              <Element className="dFlex gap1 justifyContentCenter alignItemsCenter">
                <Icon
                  className="icon-view-insight "
                  style={{
                    fontSize: 14,
                  }}
                />
                <Translate
                  value="library.detailsPortfolios.VIEW_PORTFOLIO_INSIGHT"
                  style={{ textTransform: 'capitalize' }}
                />
              </Element>
            }
            action={actionViewInsight}
          />
          <Button
            className={style.export}
            style={{
              color: ids.length ? '#2c73e8' : '#9C9C9C',
              backgroundColor: '#ffffff',
              borderColor: ids.length ? '#6d9dcf' : '#9C9C9C',
            }}
            label="library.savePortfolio.EXPORT"
            action={handleExport}
            isI18n
          />
        </Element>
      </div>
      {isShow && <PopupCreateCompany isShow={isShow} setShow={setShow} />}
    </>
  )
}
